import Checkbox from 'tio-reimagined/components/checkbox';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type EmployeeModel from '../../models/employee.ts';
import type Store from '@ember-data/store';
import type Tag from '../../models/tag.ts';

export interface TermVerifiedSignature {
  Args: {
    employee: EmployeeModel;
  };
  Element: HTMLDivElement;
}

export default class TermVerified extends Component<TermVerifiedSignature> {
  @service declare store: Store;

  toggleTermVerified = async () => {
    if (this.args.employee.isTermVerified) {
      const tag = this.args.employee.tags.find((tag) => tag.name === 'Term Verified');
      if (tag) {
        await tag.destroyRecord();
      }
    } else {
      const tag = this.store.createRecord<Tag>('tag', {
        name: 'Term Verified',
        // @ts-expect-error: need to figure out poly
        taggable: this.args.employee,
        taggableType: 'Employee',
      });
      await tag.save();
      return tag;
    }
  };

  <template>
    <Checkbox
      data-term-verified-checkbox
      @label="Term Verified"
      @onChange={{this.toggleTermVerified}}
      @checked={{@employee.isTermVerified}}
      @size="lg"
    />
  </template>
}
